import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import {addSuccessMessage} from "../SnackBar";

export const TRAINERS_PATCH_REQUEST = 'PATCH_TRAINERS_REQUEST';
export const TRAINERS_PATCH_FAILURE = 'PATCH_TRAINERS_FAILURE';
export const TRAINERS_PATCH_SUCCESS = 'PATCH_TRAINERS_SUCCESS';

export const patchTrainer = (data, id) => {
    return function(dispatch) {
        const params = [];
        params['id'] = id;
        dispatch(patchRequest());
        return axios(apiRequestOptions(apiPath.TRAINERS.PATCH, data, {params}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(patchSuccess(response.data));
                dispatch(addSuccessMessage('Trainer successfully changed'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const patchRequest = () => {
    return {
        type: TRAINERS_PATCH_REQUEST,
    }
};

const postFailure = (error) => {
    return {
        type: TRAINERS_PATCH_FAILURE,
        error,
    }
};

const patchSuccess = trainer => {
    return {
        type: TRAINERS_PATCH_SUCCESS,
        trainer,
    }
};